import { VoiceoverTone } from '@spotify-internal/ads-api-typescript-client-development';

export const TONE_OF_VOICE_OPTIONS = [
  { label: 'Conversational, friendly', key: 'conversational_friendly' },
  { label: 'Chill, serious', key: 'chill_serious' },
  { label: 'Enthusiastic, lively', key: 'enthusiastic_lively' },
];

export const VOICEOVER_TONE_MAP: Record<string, VoiceoverTone> = {
  conversational_friendly: VoiceoverTone.Conversational,
  chill_serious: VoiceoverTone.Chill,
  enthusiastic_lively: VoiceoverTone.Upbeat,
};
